module.exports = __webpack_public_path__ + "static/assets/9bd126cef4ccc5aad4387dd11adb56f9.gif";